<template>
  <div>
    <b-modal
      id="create-kit-template-modal"
      hide-header
      hide-footer
      no-stacking
      centered 
      size="lg"
      @hidden="onClose"
      @show="onShow"
    >
      <div class="modal-header">
        <div class="modal-title">{{ title ?? 'Criar novo kit' }}</div>
        <span class="icon-box"><v-close class="icon stroke" @click="onClose"/></span>
      </div>

      <div class="modal-body p-3">
        <b-row>
          <b-col cols="2">
            <label class="title">
              Código Interno
            </label>
            <b-form-input
              id="number"
              type="text"
              v-model="form.number"
              placeholder=""
              disabled
            />
          </b-col>
          <b-col cols="3">
            <label class="title">
              Identificação do Kit
            </label>
            <b-form-input
              id="kit-code"
              type="text"
              v-model="form.code"
              placeholder="Descrever"
              required
            />
          </b-col>
          <b-col cols="7">
            <label class="title">
              Nome do kit
            </label>
            <b-form-input
              id="kit-name"
              type="text"
              v-model="form.name"
              placeholder="Descrever"
              required
            />
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col cols="3">
            <label class="title">
              Preço de Custo
            </label>
            <b-form-input
                id="cost_price"
                v-model="form.cost_price"
                v-money="money"
                placeholder="R$ 0,00"
            />
          </b-col>
          <b-col cols="3">
            <label class="title">
              Preço de Venda
            </label>
            <b-form-input
                id="sale_price"
                v-model="form.sale_price"
                v-money="money"
                placeholder="R$ 0,00"
            />
          </b-col>
          <b-col cols="3">
            <label class="title">
              Aviso de vencimento
            </label>
            <b-form-input
              id="expiration_notice"
              type="number"
              v-model="form.expiration_notice"
              placeholder="Dias"
            />
          </b-col>
          <b-col cols="3">
            <label class="title">
              Quantidade mínima
            </label>
            <b-form-input
              id="minimum_quantity"
              type="number"
              v-model="form.minimum_quantity"
              placeholder="0"
            />
          </b-col>
        </b-row>
        <hr/>
        <section class="products-section mb-4">
          <b-row 
            class="mt-2"
            v-for="(product, index) in form.products" 
            :key="index"
          >
            <b-col cols="8">
              <Autocomplete
                v-model="product.product_id"
                :options="productOptions"
                placeholder="Digitar código | Bipar"
                @input="inputProduct(index, $event)"
                @update="searchProduct(index, $event)"
                debounce="1000"  
              />
            </b-col>
            <b-col cols="3">
              <div class="product-input">
                <b-form-input
                  type="number"
                  min="1"
                  :class="{'is-invalid': product?.quantity <= 0}"
                  v-model="product.quantity"
                  :id="`kit-product-quantity-${index}`"
                  placeholder="Quantidade"
                />
                <Barcode v-show="!product?.name" class="barcode"/>
              </div>
            </b-col>
            <b-col cols="1" class="text-center" align-self="center">
              <Trash 
                class="icon trash"
                @click="removeProduct(index)"
              />
            </b-col>
          </b-row>
          <b-row class="text-align-center text-left mt-3">
            <b-col cols="12">
              <b-button
                variant="outline-primary"
                @click="addProduct"
              >
                Adicionar produto
              </b-button>
            </b-col>
          </b-row>
        </section>
        <hr/>   
        
        <div class="wrapper-button text-right my-3">
          <b-button
            variant="primary" 
            :disabled="!isValidForm()"
            @click="handleSave"
          >
            Salvar
          </b-button>
        </div>
      </div>

    </b-modal>
  </div>
</template>
<script>
import { VMoney } from 'v-money'
import { parseMoneyToNumber, parseNumberToMoney } from '@/utils/moneyHelper'

export default {
  name: 'create-template-modal',
  components: {
    'v-close': () => import('@/assets/icons/close.svg'),
    Trash: () => import('@/assets/icons/trash.svg'), 
    Barcode: () => import('@/assets/icons/barcode-gray.svg'),
    Autocomplete: () => import('@/components/Autocomplete.vue'),
  },
  props: {
    title: String,
    kitTemplate: Object || null,
  },
  data () {
    return {
      form: {
        code: null,
        name: null,
        clinic_id: JSON.parse(localStorage.getItem('clinic')).id,
        products: [],
      },
      clinic: JSON.parse(localStorage.getItem('clinic')),
      productOptions: [],
      itemsToDelete: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
    }
  },
  methods: {
    parseNumberToMoney,
    parseMoneyToNumber,
    async onShow() {
      this.getInternalCode();
    },
    onClose () {
      this.productOptions = []
      this.resetForm()
      this.$emit('close')
      this.$bvModal.hide('create-kit-template-modal');
    },
    resetForm () {
      this.form = this.getDefaultForm()
    },
    getDefaultForm () {
      return {
        code: null,
        name: null,
        clinic_id: this.clinic.id,
        products: [],
      }
    },
    isValidForm () {
      const validProducts = this.form.products?.length && this.form.products.every(product => {
        return product?.product_id && product?.quantity > 0
      })
      return (
        this.form?.name?.length
        && validProducts
      )
    },
    addProduct () {
      this.form.products.push({
        id: null,
        product_id: null,
        barcode: null,
        name: null,
        quantity: 1,
      })
    },
    async searchProduct (index, code) {
      if (!code?.length) return;

      try {
        const res = await this.api.searchProducts(this.clinic.id, code) 

        const newOptions = res.data.map(product => ({
          value: product?.id,
          barcode: product?.barcode,
          name: product?.name,
          label: `${product?.barcode ? product.barcode+' -' : ''} ${product?.name}`,
          disabled: this.form.products.some(prod => prod?.product_id === product?.id),
        }))

        this.productOptions = this.productOptions.concat(newOptions)
        this.productOptions = this.productOptions.filter((option, index, self) => {
          return self.findIndex(opt => opt.value === option.value) === index
        })

        this.productOptions = this.productOptions.filter(option => option.value && option.name)

      } catch (error) {
        this.$toast.error('Não foi possível encontrar o produto, contato o suporte se o erro persistir.')
      }
    },
    setProductAsAvailable (formProductIndex) {
      const optionIndex = this.productOptions.findIndex(option => 
        option.name === this.form.products[formProductIndex].name
          && option.barcode === this.form.products[formProductIndex].barcode
      )

      if(this.productOptions[optionIndex])
        this.$set(this.productOptions[optionIndex], 'disabled', false)
    },
    removeProduct (index) {
      if (this.form?.products[index]?.pivot?.id) 
        this.itemsToDelete.push(this.form?.products[index]?.pivot?.id)

      this.setProductAsAvailable(index)

      this.form.products.splice(index, 1)
    },
    inputProduct (index, productId) {
      if (!productId) {
        this.setProductAsAvailable(index)

        this.form.products[index].product_id = null
        this.form.products[index].barcode = null
        this.form.products[index].name = null
        return;
      }

      const productOption = this.productOptions.find(option => option.value === productId)
      if (productOption)
        this.$set(productOption, 'disabled', true)

      this.form.products[index].product_id = productId
      this.form.products[index].barcode = productOption?.barcode
      this.form.products[index].name = productOption?.name 
    },
    async handleSave () {
      this.form.psychotropic_medication = !!this.form.products.find(el => el.psychotropic_medication);

      if (this.form?.id) 
        await this.updateTemplate()
      else
        await this.saveTemplate()
    },
    async saveTemplate () {
      if (!this.isValidForm()) return;

      const loading = this.$loading.show()
      try {
        const data = {
          ...this.form,
          clinic_id: this.clinic.id,
          template_products_to_delete: this.itemsToDelete,
          cost_price: this.removeCurrencyMask(this.form.cost_price),
          sale_price: this.removeCurrencyMask(this.form.sale_price),
        }

        await this.api.createKitTemplate(data)
        this.$toast.success('Kit salvo com sucesso!')
        this.$emit('save')
        this.resetForm()
      } catch (err) {
        this.$toast.error(err?.response?.data?.message)
      } finally {
        loading.hide()
      }
    },
    async updateTemplate () {
      if (!this.isValidForm()) return;

      const loading = this.$loading.show()
      try {
        const data = {
          ...this.form,
          clinic_id: this.clinic.id,
          template_products_to_delete: this.itemsToDelete,
          cost_price: this.removeCurrencyMask(this.form.cost_price),
          sale_price: this.removeCurrencyMask(this.form.sale_price),
        }

        console.log("data -->", data)

        await this.api.updateKitTemplate(this.form.id, data)
        this.$toast.success('Kit atualizado com sucesso!')
        this.$emit('save')
        this.resetForm()
      } catch (err) {
        this.$toast.error(err?.response?.data?.message)
      } finally {
        loading.hide()
      }
    },
    async getInternalCode() {
      if(!this.form.id){
        this.api.getWarehouseInternalCode(this.clinic.id)
        .then(res => {
          this.form.number = res.data.number;
        })
        .catch(err => {
          this.$toast.error(err.message);
        })
      }
    },
    removeCurrencyMask(value) {
      return value.replace('R$', '').replace('.', '').replace(',', '.');
    },
  },
  watch: {
    kitTemplate: {
      handler (value) {
        if (value && Object.keys(value).length) {
          this.productOptions = this.kitTemplate.products.map(product => ({
            value: product?.product_id,
            barcode: product?.barcode,
            name: product?.name,
            disabled: this.kitTemplate.products.some(prod => prod?.product_id === product?.product_id),
            label: `${product?.barcode ? product?.barcode+' -' : ''} ${product?.name}`,
          }))
          this.productOptions = this.productOptions.filter(option => option.value && option.name)
          this.form = this.kitTemplate
          this.form.number = value.product?.number
          this.form.expiration_notice = value.product?.expiration_notice
          this.form.minimum_quantity = value.product?.minimum_quantity
          this.form.cost_price = parseNumberToMoney(value.product?.cost_price)
          this.form.sale_price = parseNumberToMoney(value.product?.sale_price)
        } else { 
          this.resetForm()
        }
      },
      immediate: true,
      deep: true
    }
  },
  directives: { money: VMoney }
}
</script>
<style lang="scss">
#create-kit-template-modal {
  .modal-content {
    top: 50%;
    left: 50%;
    transform: translate(-50%, 0);

    .modal-body {
      padding: 0;

      textarea {
        min-height: 100px;
      }
      
      .multiselect {
        .multiselect__single {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: calc(100% - 15px);
          
          div {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }

      .help-icon {
        svg {
          height: 20px;
          padding-bottom: 3px;
        }
      }

      .sub-title {
        font-size: 18px;
        font-weight: 700;
        line-height: 24.12px;
        letter-spacing: -0.01em;
        text-align: left;
        color: #305BF2;
      }

      .modal-header {
        width: 100%;
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        padding: 24px;

        svg {
          fill: var(--neutral-500);
        }
      }

      .modal-title {
        font-family: 'Nunito Sans';
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 28px;
        color: var(--type-active);
      }

      .icon {
        width: 24px;
      }

      .md-button {
        text-align: right;
        margin: 24px 24px 24px 0;

        .button {
          font-family: 'Nunito Sans';
          font-style: normal;
          font-weight: 700;
          font-size: 16px;
          line-height: 24px;
          padding: 8px 16px;
        }
      }

      .row {

        .title {
          font-family: 'Nunito Sans';
          font-style: normal;
          font-weight: 600;
          font-size: 16px;
          line-height: 150%;
          color: var(--dark-blue);
        }

        .optional {
          font-family: 'Nunito Sans';
          font-style: normal;
          font-weight: 600;
          font-size: 12px;
          line-height: 130%;
          align-items: center;
          color: var(--type-placeholder);
          padding-left: 3px;
        }

        .no-padding {
          padding: 0 !important;

          hr {
            margin: 16px 0 0 0;
          }
        }

        .form-group {
          margin: 0 !important;
        }

        .padding_24_24_0 {
          padding: 24px 24px 0 !important;
        }

        .padding_24_0_0_24 {
          padding: 24px 0px 0 24px !important;
        }

        .padding_16_0_0_24 {
          padding: 16px 0px 0 24px !important;
        }

        .padding_24_24_0_8 {
          padding: 24px 24px 0 8px !important;
        }

        .padding_16_24_0_8 {
          padding: 16px 24px 0 8px !important;
        }

        .padding_16_0_0_8 {
          padding: 16px 0 0 8px !important;
        }
      }

      .card {
        border-radius: 5px;

        &#barcodes{
          .input-group {
            border-bottom: 1px solid #C6CEEB !important;

            .input-group-append {
              padding: 7px;
            }

            input {
              border: none !important;
              border-radius: 0px !important;

              &:disabled {
                background-color: #FFF !important;
              }
            }

            .icon-container{
              width: 35px;
              height: auto;
              cursor: pointer;
              padding: 0px 10px;

              div {
                margin: auto;

                .icon {
                  width: 25px;
                }

                .icon-plus {
                  height: auto;
                  width: 25px;
                }

                .icon-trash {
                  height: auto;
                  width: 25px;

                  path {
                    stroke: #FBA59D;
                  }
                }
              }
            }
          }
        }

        .card-header {
          color: #0C1D59;
          font-size: 16px;
          font-weight: 600;
        }
      }

      .invalid-feedback {
        width: 100%;
        margin-top: 0.25rem;
        font-size: 80%;
        color: #dc3545;
      }

      .icon {
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
      
      .trash {
        stroke: var(--states-red-soft);
      }

      .product-input {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        input {
          position: relative;
        }

        .barcode {
          position: absolute;
          margin-left: -80px;
          transform: scale(0.7);
          height: 30px;
        }
        
      }
    }
  }
}
</style>
